/*
 *   File : create-basket.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Create basket modal
 *   Integrations :
 *   Version : v1.0
 */

/*import packages*/
import React, { useEffect, useState } from "react";
import $ from "jquery";

/*import components*/
import { PrimaryBtn, SecondaryBtn } from "../../components/cta";
import { AmountInput, Input } from "../../components/input";

/*import styles*/
import modalStyle from "../../styles/components/create-basket.module.scss";

export default function CreateBasketModal(props) {
  const [basketName, setBasketName] = useState("");
  const [minSipAmount, setMinSipAmount] = useState("");
  const [minLumpsumAmount, setMinLumpsumAmount] = useState("");

  /* error states */
  const [basketNameError, setBasketNameError] = useState("");
  const [sipError, setSipError] = useState("");
  const [lumpsumError, setLumpsumError] = useState("");

  // useEffect(() => {
  //   const myModalEl = document.getElementById("create-basket");
  //   if (!myModalEl) return;

  //   const onHidden = () => {
  //     setBasketName("");
  //     setMinSipAmount("");
  //     setMinLumpsumAmount("");

  //     props?.closeModal?.();
  //   };

  //   myModalEl.addEventListener("hidden.bs.modal", onHidden);
  //   return () => myModalEl.removeEventListener("hidden.bs.modal", onHidden);
  //   //eslint-disable-next-line
  // }, []);


  useEffect(() => {

    if (props.basketCreatedStatus) {
      setBasketName("");
      setMinSipAmount("");
      setMinLumpsumAmount("");
    }

  }, [props.basketCreatedStatus]);

  const handleCreate = () => {
    let is_valid = true;

    /* Basket name validation */
    if (basketName.trim().length === 0) {
      setBasketNameError("Basket name is required");
      is_valid = false;
    } else {
      setBasketNameError("");
    }

    /* SIP validation */
    if (minSipAmount === "" || Number(minSipAmount) <= 0) {
      setSipError("Minimum SIP amount is required");
      is_valid = false;
    } else {
      setSipError("");
    }

    /* Lumpsum validation */
    if (minLumpsumAmount === "" || Number(minLumpsumAmount) <= 0) {
      setLumpsumError("Minimum lumpsum amount is required");
      is_valid = false;
    } else {
      setLumpsumError("");
    }

    if (is_valid) {
      props?.handleCreate?.({
        basket_name: basketName.trim(),
        min_sip_amount: Number(minSipAmount),
        min_lumpsum_amount: Number(minLumpsumAmount),
      });

      props?.closeModal?.();
    }
  };

  return (
    <div
      className={`${modalStyle.e_create_basket} modal fade`}
      id="create-basket"
      tabIndex="-1"
      aria-labelledby="create-basket-title"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-radius-12">
          <div className="modal-header pb-0 pt-0 px-0">
            <h6 id="create-basket-title">Create new basket</h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>

          <div className="modal-body px-0 pt-0 pb-4">
            <div className="row">

              {/* Basket name */}
              <div className="col-12 mb-3">
                <label className="mb-1">Add basket name</label>
                <Input
                  type="text"
                  placeholder="Basket name"
                  value={basketName}
                  valueChange={(v) => {
                    setBasketName(v);
                    if (basketNameError) setBasketNameError("");
                  }}
                />
                {basketNameError && (
                  <small className="text-danger">{basketNameError}</small>
                )}
              </div>

              {/* SIP */}
              <div className="col-lg-6 col-12 mb-3">
                <label className="mb-1">Min SIP amount</label>
                <AmountInput
                  placeholder="0"
                  defaultValue={minSipAmount}
                  is_zero={true}
                  valueChange={(v) => {
                    setMinSipAmount(v);
                    if (sipError) setSipError("");
                  }}
                />
                {sipError && (
                  <small className="text-danger">{sipError}</small>
                )}
              </div>

              {/* Lumpsum */}
              <div className="col-lg-6 col-12 mb-2">
                <label className="mb-1">Min lumpsum amount</label>
                <AmountInput
                  placeholder="0"
                  defaultValue={minLumpsumAmount}
                  is_zero={true}
                  valueChange={(v) => {
                    setMinLumpsumAmount(v);
                    if (lumpsumError) setLumpsumError("");
                  }}
                />
                {lumpsumError && (
                  <small className="text-danger">{lumpsumError}</small>
                )}
              </div>
            </div>
          </div>

          <div className="modal-footer d-flex justify-content-end gap-3  p-0 border-0">
            <SecondaryBtn
              name="Cancel"
              cancel="modal"
              id="close-create-basket"
              className={modalStyle.e_cancel}
            />
            <PrimaryBtn
              name="Create basket"
              // cancel="modal"
              handleClick={handleCreate}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

